import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocationHistoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"location_history"}/>
}
